import './Page.css';

const tutors = [
  {
    name: 'Nidhi Garg',
    role: 'Co-CEO | Program Director | Educational Advisor | Learning Platform Lead',
    edu: 'M.S. in Chemistry',
    bio: 'As Co-CEO and Program Director at Scholar Sphere, I\'m dedicated to helping families navigate school choices, academic planning, and test preparation with clarity and confidence. Over the last year, I\'ve supported more than 100 families—many new to the U.S. system—by offering guidance that is practical, personalized, and easy to follow. I also run our community group of 400+ parents and students, where I share important academic updates, school deadlines, SAT/ACT information, and helpful resources to keep families informed throughout the year.',
  },
  {
    name: 'Anshu Gupta',
    role: 'Co-CEO | Strategic Program Director | Parent Advocate | Educational Operations Leader',
    edu: '',
    bio: 'As Co-CEO of Scholar Sphere, I lead with purpose, precision, and a deep personal commitment to empowering families through the complex world of U.S. education. With a strong background in program design, operational leadership, and mentor alignment, I ensure our educational services are not only effective—but transformational. Having raised two children through elite academic tracks—including admissions to the Harvard Pre-College Program and the U.S. Senate Youth Program—I know exactly what it takes to support a child\'s academic journey with intention and insight.',
  },
  {
    name: 'Divij Garg',
    role: 'Tutor',
    edu: 'B.S. in Computer Science & Mathematics @ University of Illinois Urbana-Champaign',
    score: 'SAT 1600',
    exp: '6+ years',
    subjects: 'Geometry, Algebra II, Calculus BC / Calc 3, Linear Algebra, SAT, Computer Science, English Language Arts, Academic and Creative Writing.',
    why: 'With a flawless SAT score and expertise in Computer Science, Mathematics, and English Language Arts, I offer a structured, analytical tutoring approach that strengthens problem-solving, reading comprehension, and effective writing. My goal is to develop confident, independent thinkers who excel academically and communicate their ideas with clarity and purpose.',
  },
  {
    name: 'Aayushi Saxena',
    role: 'Tutor',
    edu: 'B.S. in Industrial and Systems Engineering from Texas A&M University',
    score: 'ACT Score: 36',
    exp: '5+ years',
    subjects: 'Pre-Algebra, Algebra 1, Geometry, Algebra 2, Precalculus, Trigonometry, Calculus1 (AB Calc)',
    why: 'I focus on building strong foundational skills, boosting confidence, and customizing lessons to meet each student\'s pace and learning goals. With several years of experience and a systems-driven mindset, I help students master both academic content and self-belief.',
  },
  {
    name: 'Akul Saxena',
    role: 'Tutor',
    edu: 'B.S. in Computational Biology & Mathematics @ UT Austin',
    score: 'SAT 1560 | ACT 36',
    exp: '5+ years',
    subjects: 'SAT, ACT, Math Olympiad, Geometry, Algebra II, Calculus BC / Calc 3, AP Sciences',
    why: 'With perfect test scores and an extensive background in STEM, I help students engage deeply with challenging material through a blend of rigor and encouragement. I strive to cultivate not just knowledge, but also confidence, curiosity, and academic independence.',
  },
  {
    name: 'Pranav Meraga',
    role: 'Tutor',
    edu: 'B.S. in Aerospace Engineering & Computer Science @ UC Berkeley',
    score: 'SAT 1570',
    exp: '6+ years',
    subjects: 'Geometry, Algebra II, Calculus BC / 3, SAT, AP Physics, Computer Science',
    why: 'I pair a robust foundation in Aerospace Engineering and Computer Science with extensive tutoring experience to inspire intellectual curiosity and rigor. My sessions connect theory to real-world relevance.',
  },
  {
    name: 'Esha Mujumdar',
    role: 'Tutor',
    edu: 'B.S. in Computer Science @ University of Illinois Urbana-Champaign',
    score: 'SAT 1560',
    subjects: 'SAT, Geometry, Algebra II, Calculus BC / Calc 3, AP Spanish, AP Physics',
    why: 'As a Computer Science scholar with broad interdisciplinary tutoring experience, I integrate logic, creativity, and strategy into each lesson. My sessions are customized to elevate understanding while promoting intellectual self-sufficiency across disciplines.',
  },
  {
    name: 'Adrian Zhuang',
    role: 'Tutor',
    edu: 'B.S. in Aerospace Engineering',
    score: 'SAT Score: 1580 | ACT 35',
    exp: '4+ years',
    subjects: 'SAT & ACT, Math, AP Physics',
    why: 'I bring real-world research experience and an engineering perspective to tutoring. My sessions are built on curiosity, clarity, and academic rigor, helping students tackle tough concepts while discovering their own potential.',
  },
  {
    name: 'Rohan Kher',
    role: 'Tutor',
    edu: 'B.S. in Physics @ Brown University',
    score: 'ACT 36',
    subjects: 'Geometry, Algebra II, Calculus BC / 3, AP Physics',
    why: 'As a Physics scholar at Brown with direct classroom and tutoring experience, I bring clarity and precision to intricate scientific and mathematical principles. My pedagogy emphasizes conceptual mastery, fostering a learning environment where students are empowered to reason critically and excel independently.',
  },
  {
    name: 'Sydney Walmsley',
    role: 'Tutor',
    edu: 'Ph.D. in English, Literature & Rhetoric/Writing @ USC',
    score: 'ACT 36',
    exp: '15+ years',
    subjects: 'SAT, ACT, GRE, LSAT, TOEFL, AP/IB Humanities, Math, Physics, Art Theory, History',
    why: 'My international teaching credentials and scholarly achievements enable me to offer a cross-disciplinary, globally informed tutoring experience. I foster critical inquiry and creative expression, encouraging students to see connections across subjects and think holistically.',
  },
  {
    name: 'Alexander Cuenca',
    role: 'Tutor',
    edu: 'B.S. in Mechanical Engineering @ UC Irvine',
    exp: '9+ years',
    subjects: 'Geometry, Algebra II, Calculus BC / Calc 3, Linear Algebra, AP Physics',
    why: 'With nearly a decade of applied experience and an engineering background, I offer a logical, structured approach to mastering advanced math and physics. My teaching style is calm yet challenging, designed to foster resilience, clarity, and authentic understanding.',
  },
  {
    name: 'Chandler Mclarth',
    role: 'Tutor',
    edu: 'Ph.D. in Biochemistry, Medical College of Wisconsin',
    exp: '5+ years + Adjunct Professor',
    subjects: 'AP Chemistry, AP Biology',
    why: 'As a Ph.D. scientist and college-level instructor, I possess a rare ability to distill complex biochemical and scientific content into accessible, engaging narratives. My instructions equip students with both academic precision and analytical mindset needed for competitive success in AP sciences and beyond.',
  },
  {
    name: 'Krista Vitrano',
    role: 'Tutor',
    edu: 'B.A. in English @ Licensed PEL, Illinois',
    exp: '9+ years',
    subjects: 'Reading, Writing, English Language Arts',
    why: 'With certified credentials and a nurturing teaching philosophy, I help young learners develop foundational literacy skills that set the stage for lifelong academic success. My structured yet flexible sessions are tailored to empower and inspire each child\'s unique potential.',
  },
  {
    name: 'Ana Bjelica',
    role: 'Tutor',
    edu: 'M.S. in Biological Engineering; B.S. in Chemistry, Biology & Mathematics, University of Missouri–Columbia',
    exp: '5+ years',
    subjects: 'Pre-Algebra, Algebra I & II, Geometry, Precalculus, AP Calculus, BC/Calc 3, General Chemistry, Biochemistry, AP Biology, Anatomy & Physiology, Writing, Phonetics etc.',
    why: 'I tailor every session to fit your goals and learning style. With my interdisciplinary background and personalized approach, I\'ll help you build lasting confidence across STEM, social science, and college readiness topics.',
  },
  {
    name: 'Joseph Paschal',
    role: 'Tutor',
    edu: 'M.S. in Applied Physics, B.S. in Physics',
    exp: '5+ years',
    subjects: 'Pre-Algebra, Algebra 1 & 2, Trigonometry, Pre-Calculus, AP Calculus BC/Calc 3, College Algebra, AP Physics 1, 2, C Mechanics, Astronomy, Earth Science',
    why: 'I make STEM fun, engaging, and inspiring. With my physics background and creative energy, I\'ll help you connect with science and math in a way that\'s practical, memorable, and confidence-building.',
  },
  {
    name: 'Mario Acosta',
    role: 'Tutor',
    edu: 'M.A. in English Philology, B.A. in English',
    exp: '5+ years',
    subjects: 'SAT & ACT English, TOEFL & IELTS, ELA & Creative Writing, College Essays, Personal Statements & Applications, Public Speaking & Debate, Research Methods & Citation, American, British & Comparative Literature',
    why: 'I combine linguistic theory, composition precision, and real classroom experience to help you write and communicate at the highest level. Whether it\'s test prep, essays, or speech, I\'ll help you surpass expectations.',
  },
  {
    name: 'Leisha Garg',
    role: 'College Counselor & Student Profiling Mentor, Essay Coach + Tutor',
    edu: 'B.S. Computer Science, UIUC (Full-Ride Scholarship recipient)',
    exp: '5+ years',
    bio: 'Leisha Garg is a dynamic and accomplished college counselor with firsthand experience navigating the competitive college admissions landscape. A full-ride Computer Science major at the University of Illinois Urbana-Champaign (UIUC), Leisha was also accepted into several top-tier programs, including Purdue and the University of Wisconsin–Madison for Computer Science, the Ross School of Business at the University of Michigan, and Washington University in St. Louis for Business. With a strong academic foundation and a passion for mentoring, Leisha has guided numerous high school students through the SAT, college essays, and application process. Her mentoring style is strategic, student-centered, and informed by real-world admissions success.',
  },
  {
    name: 'Chika Okaneme',
    role: 'College Counselor & Student Profiling Mentor, Essay Coach + Tutor',
    edu: 'M.S. in Journalism, Columbia University',
    exp: '6+ years',
    subjects: 'SAT & ACT, ELA, Algebra II, Geometry, Pre-Calculus, and Regents exams.',
    bio: 'Chika Okaneme is a transformative college counselor and master writing coach who empowers students to tell their stories with clarity, sophistication, and heart. A graduate of Columbia University\'s elite journalism program, Chika brings over six years of experience helping students craft compelling personal statements, ace rigorous humanities coursework, and unlock their full academic potential.',
  },
  {
    name: 'Brett Chosewood',
    role: 'College Counselor & Admissions Mentor, Essay Coach + Tutor',
    edu: 'M.S. in English Education, Piedmont University | TEFL Certified',
    exp: '13+ years',
    subjects: 'PSAT, SAT, ACT, TOEFL, GED, and ASVAB',
    bio: 'Brett Chosewood is a highly respected college admissions coach and academic strategist with over 13 years of success helping students win scholarships, secure acceptance to competitive schools and master the art of academic communication. Known for his strategic yet compassionate approach, Brett tailors every session to the student\'s voice, goals, and growth areas.',
  },
  {
    name: 'Brandon Johnson',
    role: 'College Counselor & Academic Planning Specialist',
    edu: 'M.S. in School Counseling, University of Akron | Licensed School Counselor',
    exp: '4+ years',
    bio: 'Brandon Johnson is a compassionate and results-driven college counselor who specializes in academic planning, financial aid navigation, and long-term student success. With a master\'s degree in School Counseling and licensure in the state of Ohio, Brandon has guided hundreds of high school students and their families through the often-overwhelming college admissions process—with clarity, confidence, and care.',
  },
];

const selectionSteps = [
  { step: '1. Academic Vetting', desc: 'Top scores, degrees, and experience.' },
  { step: '2. Teaching Sample', desc: 'Demonstrated clarity and engagement.' },
  { step: '3. Student Adaptability', desc: 'Ability to personalize sessions.' },
  { step: '4. Ongoing Training', desc: 'Strategy updates, AI tools, and diagnostics.' },
];

export default function TutorsPage() {
  return (
    <div className="page-wrap">
      <div className="navy-hero">
        <div className="container">
          <h1>Team Scholar Sphere</h1>
          <p className="page-hero-sub">Expert Educators | Proven Results | Personalized Support.</p>
          <div className="hero-btns">
            <a href="https://secure.tutorcruncher.com/scholar-sphere/signup/client/" target="_blank" rel="noreferrer" className="btn-gold">Book a Free Consultation</a>
          </div>
        </div>
      </div>

      <div className="container page-body">
        <div className="page-section" style = {{marginTop: 32}}>
          <h2 className="section-heading">Why Our Tutors Stand Out</h2>
          <p className="page-p">
            At Scholar Sphere, our tutors aren't just academically accomplished—they're mentors, motivators, and student success partners. Each one is handpicked for their subject mastery, teaching experience, and passion for helping students grow.
          </p>
          <ul className="check-list">
            <li>Top Universities or Ivy League Scholars.</li>
            <li>Expertise on SAT, ACT, ELA, AP, or more.</li>
            <li>Trained in personalized instruction and strategy.</li>
            <li>Committed to real results—not just rote learning.</li>
          </ul>
        </div>

        <div className="page-section">
          <h2 className="section-heading">Meet the Scholar Sphere Team!</h2>
          <div className="tutor-grid">
            {tutors.map(t => (
              <div className="tutor-card" key={t.name}>
                <div className="tutor-avatar">{t.name[0]}</div>
                <div className="tutor-name">{t.name}</div>
                <div className="tutor-role">{t.role}</div>
                {t.edu && <div className="tutor-edu">🎓 {t.edu}</div>}
                {t.score && <div className="tutor-score">📊 {t.score}</div>}
                {t.exp && <div className="tutor-score">⏳ Experience: {t.exp}</div>}
                {t.subjects && <div className="tutor-subjects">Subjects: {t.subjects}</div>}
                <p className="tutor-why">{t.bio || t.why}</p>
              </div>
            ))}
          </div>
        </div>

        <div className="page-section">
          <h2 className="section-heading">How We Select & Train Our Tutors</h2>
          <p className="page-p">Every Scholar Sphere tutor goes through a rigorous 4-step screening process:</p>
          <div className="why-boxes">
            {selectionSteps.map(s => (
              <div className="why-box" key={s.step}>
                <div className="why-box-title">{s.step}</div>
                <div className="why-box-desc">{s.desc}</div>
              </div>
            ))}
          </div>
          <p className="page-p" style={{ fontWeight: 700, color: 'var(--navy)' }}>
            95% of families report visible academic improvement within 4 weeks.
          </p>
        </div>

        <div className="cta-strip" style={{marginBottom: 32}}>
          <h3>Ready to Work with a Tutor You Can Trust?</h3>
          <p style={{ color: 'rgba(255,255,255,0.8)', marginBottom: 20, fontSize: 15 }}>
            Get matched with the right tutor for your child's goals. Flexible 1:1 sessions or small-group options available. Free consultation for all new students.
          </p>
          <a href="https://secure.tutorcruncher.com/scholar-sphere/signup/client/" target="_blank" rel="noreferrer" className="btn-gold">Book a Free Consultation</a>
        </div>
      </div>
    </div>
  );
}
